/* eslint-disable no-use-before-define */
/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import MockAdapter from 'axios-mock-adapter';
import { getOrProduce } from '@domain/utils/data.utils';

// This is a temporary measure, so we can build components already considering actual requests.
// When this is no more needed, we could replace its usages by 'axios.create' directly.

export function createMockedAxios(config?: AxiosRequestConfig): AxiosInstance {
  const instance = axios.create(config);

  const mock = new MockAdapter(instance, { delayResponse: 2000, onNoMatch: 'passthrough' });

  mock.onGet('/admin/send-bonus').reply(success());

  mock.onGet('/admin/send-stats').reply(success());

  mock.onPost('/admin/clean-cache').reply(success());

  mock.onPost('/admin/block-player').reply(success());

  mock.onPost('/admin/set-tester').reply(success());

  mock.onPost('/admin/change-payments').reply(success());

  mock.onPost('/admin/change-action-logging').reply(success());

  return instance;
}

type CallbackResponseSpecFunc = (config: AxiosRequestConfig) => any[] | Promise<any[]>;

function success(data?: any | (() => any)) {
  return reply(200, data);
}

function error(data?: any | (() => any)) {
  return reply(400, data);
}

function reply(status: number, data?: any | (() => any)): CallbackResponseSpecFunc {
  return (config) => {
    console.warn(`Mocking ${config.method?.toUpperCase()} request to '${config.url}'`);
    return [status, getOrProduce(data)];
  };
}
